enum Interests {
  UNDERSTAND_MY_FERTILITY = "UNDERSTAND_MY_FERTILITY",
  INITIAL_FERTILITY_TESTING = "INITIAL_FERTILITY_TESTING",
  EMBRYO_FREEZING = "EMBRYO_FREEZING",
  EGG_FREEZING = "EGG_FREEZING",
  SPERM_FREEZING = "SPERM_FREEZING",
  IVF = "IVF",
  IUI = "IUI",
  ADOPTING = "ADOPTING",
  GESTATIONAL_CARRIER = "GESTATIONAL_CARRIER",
  SOMETHING_ELSE = "SOMETHING_ELSE",
  PREGNANCY = "PREGNANCY",
  TRYING_TO_GET_PREGNANT = "TRYING_TO_GET_PREGNANT",
  PREGNANT = "PREGNANT"
}

export default Interests
